import * as React from 'react';
import {FACompsBySeasonDate, FAComps} from '@nls-2022/nls-bll';
import {Select} from './BlogFormInputs';
//export type BlogPostSelectRoundPropsType = {
//  handleCompChange: any;
//  selectedSeason: string;
//  selectedComp: string | undefined | null;
//};

const BlogPostSelectCompGeneric = ({
  register,
  selectedSeason,
  setValue,
  selectedComp,
  compBySeason,
}: any) => {
  React.useEffect(() => {
    console.log('Select Comp Use Effect ' + selectedSeason);
  }, [selectedSeason, setValue, selectedComp]);
  let compDataforSeason = compBySeason.find((u: {season: any}) => {
    return u.season === selectedSeason;
  });
  if (compDataforSeason === undefined || compDataforSeason === null) {
    return <></>;
  }
  let compDetails: Array<string> | undefined =
    compDataforSeason.compDetailsList.map(
      (i: {comp: any}) =>
        FAComps.find((g: {comp: any}) => i.comp === g.comp)!.name,
    );
  let uniqCompDetails = compDetails!.filter((x, i, a) => a.indexOf(x) === i);

  return (
    <div className="mb-4 mr-4">
      <label className="block text-gray-700 text-sm font-bold mb-2">
        Competition
      </label>
      <Select
        name="Comp"
        register={register}
        options={uniqCompDetails}
        defaultValue={selectedComp}
      />
    </div>
  );
};
export default BlogPostSelectCompGeneric;
